export default "__VITE_ASSET__DMmsrPub__"